import React from 'react';
import Debts from '../Debts';

function DebtsPage() {
    return (
        <Debts />
    );
}

export default DebtsPage;